module.exports = __webpack_public_path__ + "assets/img/num-04-56a35e1f.png";